import { DEFAULT_CAPTION_STYLE } from './textStylePresets';

const TYPEWRITER_ANIMATION = 'typewriter';

export const isTypewriterCaptionStyle = (style = {}) => {
  if (!style || typeof style !== 'object') return false;
  return (
    style.animation === TYPEWRITER_ANIMATION ||
    style.displayMode === TYPEWRITER_ANIMATION
  );
};

export const normalizeHighlightStyle = (style = {}) => {
  if (!style || typeof style !== 'object') return {};
  return { ...style };
};

export const sanitizeCaptionStyle = (style = {}) => {
  const normalized = normalizeHighlightStyle(style);
  const nextStyle = { ...normalized };
  const activeWordBlur = (
    normalized.activeWordBlur === true ||
    normalized.activeWordBlur === 'true' ||
    Number(normalized.activeWordBlur) === 1
  );
  nextStyle.activeWordBlur = activeWordBlur;
  if (activeWordBlur) {
    // Blur reveal should not run per-word entrance animation; it causes glyph flash-through.
    nextStyle.wordAnimation = null;
  }

  if (!activeWordBlur) {
    nextStyle.activeWordBlurColor = null;
    nextStyle.activeWordBlurRadius = null;
    nextStyle.activeWordBlurTrailMs = null;
    nextStyle.activeWordBlurRevealMs = null;
    nextStyle.activeWordBlurOpacity = null;
    nextStyle.activeWordBlurOffsetX = null;
    nextStyle.activeWordBlurOffsetY = null;
    nextStyle.activeWordBlurWordAlpha = null;
    nextStyle.activeWordBlurXRatio = null;
  }

  // Temporarily disabled advanced caption styling while we focus on core controls.
  // nextStyle.maxLines = nextStyle.maxLines;
  // nextStyle.backgroundColor = nextStyle.backgroundColor;
  // nextStyle.backgroundPaddingX = nextStyle.backgroundPaddingX;
  // nextStyle.dropShadow = nextStyle.dropShadow;
  // nextStyle.dropShadowColor = nextStyle.dropShadowColor;
  // nextStyle.dropShadowBlur = nextStyle.dropShadowBlur;
  // nextStyle.dropShadowDistance = nextStyle.dropShadowDistance;

  nextStyle.maxLines = DEFAULT_CAPTION_STYLE.maxLines ?? 1;
  nextStyle.backgroundColor = null;
  nextStyle.backgroundPaddingX = DEFAULT_CAPTION_STYLE.backgroundPaddingX ?? 16;
  nextStyle.dropShadow = false;
  nextStyle.dropShadowColor = DEFAULT_CAPTION_STYLE.dropShadowColor || '#000000';
  nextStyle.dropShadowBlur = DEFAULT_CAPTION_STYLE.dropShadowBlur ?? 4;
  nextStyle.dropShadowDistance = DEFAULT_CAPTION_STYLE.dropShadowDistance ?? 0;

  return nextStyle;
};

export const shouldUseWordContainer = (style = {}) => {
  const normalizedStyle = sanitizeCaptionStyle(style);
  if (isTypewriterCaptionStyle(normalizedStyle)) return false;
  return Boolean(
    normalizedStyle.highlightColor ||
    normalizedStyle.highlightBg ||
    normalizedStyle.displayMode ||
    normalizedStyle.activeWordBlur
  );
};
